// @flow
import { featureIsEnabled } from '@ta/common.features';

const ALWAYS = () => true;

const types: $ReadOnly<{ [string]: () => boolean }> = {
  ATTRACTION_PRODUCT: () => featureIsEnabled('allow_attraction_product_feed'),
  CRUISE_SEARCH_ITEM: () => featureIsEnabled('allow_cruise_search_item_feed'),
  // dmo shelves require crusts (ML-2591)
  DMO_SPONSORED_PROFILE_ITEM: () => featureIsEnabled('allow_dmo_sponsored_profile_shelf_web'),
  DMO_COMPETITOR_PROFILE: () => featureIsEnabled('allow_dmo_competitor_geo_sponsors'),
  DFP_AD_ITEM: () => featureIsEnabled('allow_dmo_dfp_ad_shelf'),
  LINK_POST: () => featureIsEnabled('allow_link_post_feed'),
  LOCATION: ALWAYS,
  MEMBER: ALWAYS,
  PHOTO: ALWAYS,
  MEDIA_BATCH: ALWAYS,
  REPOST: () => featureIsEnabled('allow_repost_feed'),
  REVIEW: () => featureIsEnabled('allow_review_feed'),
  TRIP: () => featureIsEnabled('trips_2018_home_profile'),
  VIDEO: () => featureIsEnabled('allow_video_feed'),
  FLIGHTS_DESTINATION_ITEM: () => featureIsEnabled('allow_flight_destination_item_feed'),
  RENTAL_CARS: () => featureIsEnabled('allow_rental_cars_item_feed'),
  GEO_OVERVIEW: ALWAYS,
  RECOMMENDED_LOCATION: () => featureIsEnabled('allow_recommended_location_feed'),
  HEADER: ALWAYS,
  CATEGORY_SEARCH: ALWAYS,
};
export const Types: $ReadOnlyArray<string> = Object.keys(types);

const tourismTypes: $ReadOnly<{ [string]: () => boolean }> = {
  ATTRACTION_PRODUCT: () => featureIsEnabled('allow_attraction_product_feed'),
  CRUISE_SEARCH_ITEM: () => featureIsEnabled('allow_cruise_search_item_feed'),
  // dmo shelves require crusts (ML-2591)
  DMO_SPONSORED_PROFILE_ITEM: () => featureIsEnabled('allow_dmo_sponsored_profile_shelf_web'),
  DMO_COMPETITOR_PROFILE: () => featureIsEnabled('allow_dmo_competitor_geo_sponsors'),
  LINK_POST: () => featureIsEnabled('allow_link_post_feed'),
  LOCATION: ALWAYS,
  MEMBER: ALWAYS,
  PHOTO: ALWAYS,
  MEDIA_BATCH: ALWAYS,
  REPOST: () => featureIsEnabled('allow_repost_feed'),
  REVIEW: () => featureIsEnabled('allow_review_feed'),
  TRIP: () => featureIsEnabled('trips_2018_home_profile'),
  VIDEO: () => featureIsEnabled('allow_video_feed'),
  FLIGHTS_DESTINATION_ITEM: () => featureIsEnabled('allow_flight_destination_item_feed'),
  GEO_OVERVIEW: ALWAYS,
  FILTER: ALWAYS,
};
export const TourismTypes: $ReadOnlyArray<string> = Object.keys(tourismTypes);

export const getAllowedTypes: (filter: ?Array<string>) => Array<string> = list =>
  Object.keys(types).filter(type => types[type]() && (!list || list.includes(type)));

export const getAllowedTourismTypes: (filter: ?Array<string>) => Array<string> = list =>
  Object.keys(tourismTypes).filter(type => tourismTypes[type]() && (!list || list.includes(type)));
